module.exports = __webpack_public_path__ + "static/b2ca12ca636860705d60eb64c6cff4c7fc58a898e2ec64cad9804f7dcfca048c-bda9fabca8a06705a9539fc8568e0edc.png";